import { Component, ViewChild, Input } from '@angular/core';
import { IonicPage, Events, NavController, NavParams, ModalController, AlertController, ToastController } from 'ionic-angular';

import { ApiProvider } from '../../providers/api/api';
import { UserProvider } from '../../providers/user/user';
import { ConfigProvider } from '../../providers/config/config';
import { SiriProvider } from '../../providers/siri/siri';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  constructor(public navCtrl: NavController) {

  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts